// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2151m","buttons":"PendingPaymentAlert_buttons__3gezj"};